import { Box, Typography } from "@mui/material";
import CustomersTable from "./table";

const CustomersList = () => {
  return (
    <Box p={{ xs: "20px 12px", md: "30px 20px", lg: "30px 30px" }}>
      <Typography fontWeight={600} fontSize={"22px"} mb={{ xs: 2, md: 4 }}>
        Customers List
      </Typography>

      <CustomersTable />
    </Box>
  );
};

export default CustomersList;
